export const ORDENES_COMPRA = 'ORDEN_COMPRA'

export const __dictionary = {
  [ORDENES_COMPRA]: {
    id: ORDENES_COMPRA,
    nombre: 'ORDEN COMPRA'
  }
}

export const __array = [__dictionary[ORDENES_COMPRA]]
